<template>
  <div>
    <v-dialog v-model="createboxDialog" persistent width="500px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0 white--text">
          <v-toolbar-title>Create RFID</v-toolbar-title><v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-3"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text>
          <div class="mt-5">
            <v-form ref="form">
              <v-text-field
                dense
                outlined
                label="Box Number"
                v-model="boxNumber"
                :rules="[(v) => !!v || 'required']"
              />
              <v-select
  v-model="OrgNameStatus"
  :items="AllOrgObject"
  dense
  outlined
  class=""
  label="Organization Name"
  item-text="organisation_name"
  item-value="organisation_id"
  :rules="[(v) => !!v || 'required']"
  return-object
></v-select>

            </v-form>
          </div>
        </v-card-text>
        <div class="d-flex justify-center mb-3">
          <v-card-actions class="">
            <v-btn
              color="primary"
              class="white--text mt-n6"
              :loading="loading"
              @click="create_rfidbox()"
              >Create</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { add_rfid_box } from "@/graphql/mutations.js";

export default {
  components: {},
  props: {
    createboxDialog: Boolean,
    AllOrgObject: Array,
  },
  data: () => ({
    loading: false,
    boxNumber: "",
    OrgNameStatus: "",
  }),
  watch: {
    createboxDialog: {
      async handler() {
        {
          if (this.createboxDialog == true) {
            var abc = this.AllOrgObject;
            console.log(abc)
            var xyz = this.$store.getters.get_useremail;
            console.log("xyz",xyz)
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    close_dialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("clicked", 0);
    },
    async create_rfidbox() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await API.graphql(
            graphqlOperation(add_rfid_box, {
              input: {
                box_id: this.boxNumber,
            organisation_id: this.OrgNameStatus.organisation_id,
            organisation_name: this.OrgNameStatus.organisation_name,
            created_by: this.$store.getters.get_useremail,
              },
            })
          );
          // console.log(result);
          var response = JSON.parse(result.data.add_rfid_box);
          this.loading = false;
          if (response.Status == "Success") {
            this.$emit("successMsg", response.Message);
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.loading = false;
          } else {
            this.$emit("errorMsg", response.Message);
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
          this.$emit("errorMsg", error.errors[0].message);
          this.loading = false;
        }
      }
    },
  },
};
</script>